import { IngredientNutriments } from '../../ui/utils/Nutriments'

export const IngredientInfo = ({
  doc
}) => <IngredientNutriments ingredient={doc} />

